import api from '../api/client'
import brand from '../brand.js'
import { initNativePush } from './useNativePush'
import { t } from '../i18n/index.js'

/** Temporary: report what Capacitor exposes on this device, to debug push. */
export async function reportNativeDiag() {
  try {
    const Cap = typeof window !== 'undefined' ? window.Capacitor : null
    await api.post('/push/diag', {
      hasCapacitor: !!Cap,
      isNative: !!Cap?.isNativePlatform?.(),
      platform: Cap?.getPlatform?.() || 'web',
      plugins: Cap?.Plugins ? Object.keys(Cap.Plugins) : [],
      ua: (typeof navigator !== 'undefined' ? navigator.userAgent : '').slice(0, 160),
    })
  } catch (_) {}
}

/**
 * Native-app setup: proactive first-launch permission requests + Face ID app
 * lock. All no-ops in a normal browser/PWA. Native plugins are reached through
 * Capacitor's bridge proxy (window.Capacitor.Plugins.*) — the web bundle stays
 * free of Capacitor dependencies.
 */
const PERMS_FLAG = 'hr_perms_requested_v1'
const LOCK_KEY   = 'hr_biometric_lock'   // '1' = enabled (per-device)

export function isNative() {
  const Cap = typeof window !== 'undefined' ? window.Capacitor : null
  return !!(Cap?.isNativePlatform?.())
}
function bio() { return (typeof window !== 'undefined' && window.Capacitor?.Plugins?.BiometricAuthNative) || null }

export function firstLaunchPending() { return isNative() && !localStorage.getItem(PERMS_FLAG) }

/**
 * On first launch inside the iOS app, surface the system prompts for the two
 * permissions the app actually needs: notifications (APNs) + location (punch).
 * Camera/photos stay in-context (requested when the user uploads).
 */
export async function runFirstLaunchPermissions() {
  if (!isNative()) return
  localStorage.setItem(PERMS_FLAG, '1')
  await initNativePush()   // notifications
  try {
    // Triggering geolocation surfaces the iOS location prompt (WKWebView honours
    // it via NSLocationWhenInUseUsageDescription).
    await new Promise((res) => navigator.geolocation?.getCurrentPosition(() => res(), () => res(), { timeout: 8000 }))
  } catch (_) { /* prompt shown is enough */ }
}

// ─── Face ID / Touch ID app lock ────────────────────────────────────
export async function biometryAvailable() {
  const B = bio(); if (!B) return false
  try { const r = await B.checkBiometry(); return !!r?.isAvailable } catch { return false }
}
export function biometricLockEnabled() { return localStorage.getItem(LOCK_KEY) === '1' }
export function setBiometricLock(on) { localStorage.setItem(LOCK_KEY, on ? '1' : '0') }

/** Prompt Face ID/Touch ID. Returns true on success, false on cancel/failure. */
export async function authenticateBiometric() {
  const B = bio(); if (!B) return true   // not native → nothing to gate
  try {
    await B.authenticate({
      reason: t('افتح تطبيق {name}', { name: brand.name }),
      cancelTitle: t('إلغاء'),
      iosFallbackTitle: t('استخدم رمز الجهاز'),
      allowDeviceCredential: true,
    })
    return true
  } catch (_) { return false }
}
